export const MOCK_DATA: any[] = [
	{
		uuId: '1234567890',
		title: '10% off',
		type: 'percentage' as 'percentage' | 'fixed',
		value: 10,
		code: '10OFF',
		amount: 0,
		usedAmount: 0,
		totalAmount: 100,
		order: 100,
		startDate: '2021-09-01T00:00:00.000Z',
		endDate: '2021-09-30T00:00:00.000Z',
		description: '10% off for all products',
		featurePicturePath: 'https://via.placeholder.com/150',
	},
	{
		uuId: '1234567890',
		title: '20% off',
		type: 'percentage' as 'percentage' | 'fixed',
		value: 20,
		code: '20OFF',
		amount: 0,
		usedAmount: 0,
		totalAmount: 100,
		order: 100,
		startDate: '2021-09-01T00:00:00.000Z',
		endDate: '2021-09-30T00:00:00.000Z',
		description: '20% off for all products',
		featurePicturePath: 'https://via.placeholder.com/150',
	},
	{
		uuId: '1234567890',
		title: '30% off',
		type: 'percentage' as 'percentage' | 'fixed',
		value: 30,
		code: '30OFF',
		amount: 0,
		usedAmount: 0,
		totalAmount: 100,
		order: 100,
		startDate: '2021-09-01T00:00:00.000Z',
		endDate: '2021-09-30T00:00:00.000Z',
		description: '30% off for all products',
		featurePicturePath: 'https://via.placeholder.com/150',
	},
	{
		uuId: '1234567890',
		title: '40% off',
		type: 'percentage' as 'percentage' | 'fixed',
		value: 40,
		code: '40OFF',
		amount: 0,
		usedAmount: 0,
		totalAmount: 100,
		order: 100,
		startDate: '2021-09-01T00:00:00.000Z',
		endDate: '2021-09-30T00:00:00.000Z',
		description: '40% off for all products',
		featurePicturePath: 'https://via.placeholder.com/150',
	},
	{
		uuId: '1234567890',
		title: '50% off',
		type: 'percentage' as 'percentage' | 'fixed',
		value: 50,
		code: '50OFF',
		amount: 0,
		usedAmount: 0,
		totalAmount: 100,
		order: 100,
		startDate: '2021-09-01T00:00:00.000Z',
		endDate: '2021-09-30T00:00:00.000Z',
		description: '50% off for all products',
		featurePicturePath: 'https://via.placeholder.com/150',
	},
	{
		uuId: '1234567890',
		title: '200 Baht off',
		type: 'fixed' as 'percentage' | 'fixed',
		value: 200,
		code: '200OFF',
		amount: 200,
		usedAmount: 0,
		totalAmount: 100,
		order: 100,
		startDate: '2021-09-01T00:00:00.000Z',
		endDate: '2021-09-30T00:00:00.000Z',
		description: '200 Baht off for all products',
		featurePicturePath: 'https://via.placeholder.com/150',
	},
	{
		uuId: '1234567890',
		title: '500 Baht off',
		type: 'fixed' as 'percentage' | 'fixed',
		value: 500,
		code: '500OFF',
		amount: 500,
		usedAmount: 0,
		totalAmount: 100,
		order: 100,
		startDate: '2021-09-01T00:00:00.000Z',
		endDate: '2021-09-30T00:00:00.000Z',
		description: '500 Baht off for all products',
		featurePicturePath: 'https://via.placeholder.com/150',
	},
	{
		uuId: '1234567890',
		title: '1000 Baht off',
		type: 'fixed' as 'percentage' | 'fixed',
		value: 1000,
		code: '1000OFF',
		amount: 1000,
		usedAmount: 0,
		totalAmount: 100,
		order: 100,
		startDate: '2021-09-01T00:00:00.000Z',
		endDate: '2021-09-30T00:00:00.000Z',
		description: '1000 Baht off for all products',
		featurePicturePath: 'https://via.placeholder.com/150',
	},
	{
		uuId: '1234567890',
		title: '1500 Baht off',
		type: 'fixed' as 'percentage' | 'fixed',
		value: 1500,
		code: '1500OFF',
		amount: 1500,
		usedAmount: 0,
		totalAmount: 100,
		order: 100,
		startDate: '2021-09-01T00:00:00.000Z',
		endDate: '2021-09-30T00:00:00.000Z',
		description: '1500 Baht off for all products',
		featurePicturePath: 'https://via.placeholder.com/150',
	},
	{
		uuId: '1234567890',
		title: '2000 Baht off',
		type: 'fixed' as 'percentage' | 'fixed',
		value: 2000,
		code: '2000OFF',
		amount: 2000,
		usedAmount: 0,
		totalAmount: 100,
		order: 100,
		startDate: '2021-09-01T00:00:00.000Z',
		endDate: '2021-09-30T00:00:00.000Z',
		description: '2000 Baht off for all products',
		featurePicturePath: 'https://via.placeholder.com/150',
	},
]
